import { render } from "./RegionMenu.vue?vue&type=template&id=85695172&ts=true"
import script from "./RegionMenu.vue?vue&type=script&lang=ts"
export * from "./RegionMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__